import CollapsibleListItem from 'components/common/CollapsibleList/CollapsibleListItem';
import { MuiBox, MuiPaper } from 'theme/material-ui';
import React from 'react';
import { AnalyticsEvent } from 'services/AnalyticsService';
import { IconSize } from 'modules/styles/variables';
import { Color } from 'modules/styles/colors';
import Svg from 'components/UI/Svg/Svg';
import { StyledTitle, StyledMuiBoxContainer } from './styled';
import { Link } from 'react-router-dom';

const costEstimatorStaticData = [
  {
    title: 'Search for services and procedures',
    to: '/u/estimate-costs'
  }
];

export const GetCareCostEstimatorList = () => {
  return (
    <CollapsibleListItem
      leftIcon="WebCostEstimator"
      title="Cost Estimator"
      subtitle="Estimate the cost of procedures"
      error={false ? 'An issue occurred' : undefined}
      analyticsEvent={AnalyticsEvent.EstimateCostsClicked}
      sourceUrlForAnalytics="Get Care"
    >
      <MuiBox width="100%">
        <MuiPaper data-testid="search-for-services-and-procedures-link" elevation={1}>
          {costEstimatorStaticData.map(item => (
            <Link to={item.to} key={item.title}>
              <StyledMuiBoxContainer>
                <StyledTitle color="textPrimary">{item.title}</StyledTitle>
                <MuiBox flex={1} flexDirection="row" justifyContent="flex-end" display="flex">
                  <Svg
                    set="material"
                    name="keyboard-arrow-right"
                    size={IconSize.base}
                    fill={Color.black}
                  />
                </MuiBox>
              </StyledMuiBoxContainer>
            </Link>
          ))}
        </MuiPaper>
      </MuiBox>
    </CollapsibleListItem>
  );
};
